module.exports = __webpack_public_path__ + "_/img/icon-account.fc84fe6d.svg";